import { Box, Button, Dialog, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { AddorEditGlobalTriggerStyles } from "./TriggerStyle";
import BasicInput from "../custom/BasicInput";
import {
  AGENCY_BUSINESS_TYPE,
  PERMISSION_LEVELS,
  PERMISSION_MODULES,
  PRIVACY_LEVEL,
  PRIVACY_LEVEL_VALUE,
} from "../../helpers/CoreConstant";
import BasicSelect from "../custom/BasicSelect";
import { useDispatch, useSelector } from "react-redux";
import { addTrigger, getTriggerFolder } from "./actions/globalTriggerAction";
import TriggerSettings from "./TriggerSettings/TriggerSettings";
import { resetTriggerActions } from "./actions/triggerAction";
import Utils from "../addContact/Utils";

const PrivacyLevelOptions = [
  { value: PRIVACY_LEVEL.PRIVACY_LEVEL_PRIVATE, title: "My Triggers" },
  { value: PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL, title: "Global  Triggers" },
];

const isAgencyTypeInsurance = Utils.getAccountData("agencyBusinessType") === AGENCY_BUSINESS_TYPE.INSURANCE;

const GlobalAddTriggerModal = ({ open, data = {}, edit, onClose }) => {
  const {
    isAddingTrigger,
    isUpdatingTrigger,
    triggerFolderList,
    triggerParams,
  } = useSelector((state) => state.globalTriggerReducer);

  const canUserManageGlobalItem = window.hasPermission(
    PERMISSION_MODULES.MANAGE_GLOBAL_ITEMS,
    PERMISSION_LEVELS.WRITE
  );
  const updatedPrivacyOptions = canUserManageGlobalItem
    ? PrivacyLevelOptions
    : [...PrivacyLevelOptions.slice(0, -1)];

  const [formData, setFormData] = useState({
    title: null,
    privacy_level: canUserManageGlobalItem ? PrivacyLevelOptions[1].value : updatedPrivacyOptions[0].value,
    user_trigger_folder_id: triggerParams.user_trigger_folder_id
      ? triggerParams.user_trigger_folder_id
      : triggerFolderList[0]?.id,
  });
  const [error, setError] = useState({
    title: "",
    privacy_level: "",
    user_trigger_folder_id: "",
  });

  const [activeScreen, setActiveScreen] = useState("ADD");

  useEffect(() => {
    dispatch(getTriggerFolder());
  }, []);

  const dispatch = useDispatch();

  const handlePrivacyLevel = (e) => {
    setFormData({ ...formData, privacy_level: e.target.value });
  };

  const handlefolder = (e) => {
    setFormData({ ...formData, user_trigger_folder_id: e.target.value });
  };

  const isFormDataChanged =
    formData.title !== edit?.title ||
    formData.privacy_level !== edit?.privacy_level ||
    formData.user_trigger_folder_id !== edit?.user_trigger_folder_id;

  const validationForm = () => {
    const errors = {};

    if (!formData.title?.trim()) {
      errors.title = "Title is required.";
    } else if (formData.title.length > 100) {
      errors.title = "Title must not exceed 100 characters.";
    }

    setError(errors);

    return Object.keys(errors).length === 0;
  };

  const handleClose = () => {
    onClose();
    if (data?.onClose) {
      data.onClose();
    }
    setActiveScreen("ADD");
    dispatch(resetTriggerActions(true))
  };
  const handleSubmit = () => {
    if (!validationForm()) {
      return;
    }

    if (edit) {
      //   formData.id = edit.id;
      //   dispatch(
      //     updateTrigger({
      //       ...formData,
      //       callback: () => {
      //         dispatch(
      //           recallTrigger({
      //             user_trigger_folder_id:
      //               formData.user_trigger_folder_id !==
      //               edit?.user_trigger_folder_id
      //                 ? formData.user_trigger_folder_id
      //                 : null,
      //             privacy_level:
      //               formData.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_PRIVATE
      //                 ? PRIVACY_LEVEL_VALUE.PRIVATE
      //                 : PRIVACY_LEVEL_VALUE.GLOBAL,
      //           })
      //         );
      //         onClose();
      //       },
      //     })
      //   );
    } else {

      const payload = isAgencyTypeInsurance ? formData : {title: formData.title}

      dispatch(
        addTrigger({
          ...payload,
          callback: (res) => {
            setActiveScreen(res.id);
            // history.push("/trigger/settings/" + res.id);
          },
        })
      );
    }
  };

  const { root, titleHeader, errorText, errorStyle, saveButton } =
    AddorEditGlobalTriggerStyles();

  const renderActiveScreen = () => {
    if (activeScreen === "ADD") {
      return (
        <Box minWidth={600} minHeight={300} className={root}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            padding={2}
            borderBottom={"1px solid #d3d3d3"}
          >
            <Typography className={titleHeader}>
              {edit ? "Edit Trigger" : "Add New Trigger"}
            </Typography>
          </Box>
          <Box minHeight={169} padding={2}>
            {edit && edit.privacy_level === "GLOBAL" && (
              <Box>
                <Box mt={1}>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "var(--dark_blue)",
                      fontWeight: 500,
                      textAlign: "center",
                    }}
                  >
                    You are attempting to edit the global trigger that you
                    represent in your agency. <br />
                    This change will be applied to all users on your team.
                  </div>
                </Box>
              </Box>
            )}
            <Box>
              <Typography className={`${error.title ? errorText : ""}`}>
                Title<span style={{ color: "var(--red)" }}>*</span>
              </Typography>
              <Box mt={1}>
                <BasicInput
                  fullWidth
                  placeholder="Trigger Name"
                  style={{ color: "var(--dark_blue)" }}
                  className={`${error.title ? errorStyle : ""}`}
                  value={formData.title}
                  onChange={(e) => {
                    setError({ ...error, title: "" });
                    setFormData({ ...formData, title: e.target.value });
                  }}
                />
                {error.title && (
                  <Typography variant="body2" className={errorText}>
                    {error.title}
                  </Typography>
                )}
              </Box>
            </Box>

            {isAgencyTypeInsurance && (
              <>
                <Box paddingTop={2}>
                  <Typography>Privacy Level</Typography>
                  <div style={{ width: "100%" }}>
                    <BasicSelect
                      fullWidth
                      value={formData.privacy_level || ""}
                      defaultText="Select Privacy level"
                      onChange={(e) => handlePrivacyLevel(e)}
                      displayEmpty
                      options={updatedPrivacyOptions}
                      mapping={{ label: "title", value: "value" }}
                    />
                  </div>
                </Box>

                <Box paddingTop={2}>
                  <Typography>Select a Folder</Typography>
                  <div style={{ width: "100%" }}>
                    <BasicSelect
                      fullWidth
                      value={formData.user_trigger_folder_id || ""}
                      defaultText="Select a Folder"
                      onChange={(e) => handlefolder(e)}
                      displayEmpty
                      options={triggerFolderList || []}
                      mapping={{ label: "name", value: "id" }}
                    />
                  </div>
                </Box>
              </>
            )}
            
          </Box>
          <Box
            padding={2}
            borderTop={"1px solid #d3d3d3"}
            display={"flex"}
            justifyContent={"end"}
            fullWidth
          >
            <Box display={"flex"} gridGap={8}>
              <Button
                style={{ backgroundColor: "#e0e0e0", textTransform: "capitalize", fontWeight: 600, padding: "6px 16px", borderRadius: "5px", }}
                onClick={handleClose}
                variant="contained"
                color="inherit"
                disableElevation
              >
                Cancel
              </Button>
              <Button
                disabled={
                  (edit && !isFormDataChanged) ||
                  isAddingTrigger ||
                  isUpdatingTrigger
                }
                onClick={handleSubmit}
                className={saveButton}
                variant="contained"
                disableElevation
              >
                {edit
                  ? isUpdatingTrigger
                    ? "Updating..."
                    : "Update"
                  : isAddingTrigger
                  ? "Saving..."
                  : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      );
    } else {
      return <TriggerSettings modalData={data} handleClose={handleClose} triggerId={activeScreen} />;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="newfolder-dialog-title"
      aria-describedby="newfolder-dialog-description"
      fullWidth={activeScreen !== "ADD" ? true : false}
      maxWidth={activeScreen !== "ADD" ? "xl" : ""}
    >
      {renderActiveScreen()}
    </Dialog>
  );
};

export default GlobalAddTriggerModal;
